// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlertBar_wrapper__2slN-","layout":"AlertBar_layout__NYheK","fixedContent":"AlertBar_fixedContent__3II3K","content":"AlertBar_content__t2K4N"};